function FlowProgressForVersion(
  activityId: string,
  flowId: string,
  version: string
) {
  return `/flow/${flowId}/version/${version}/activity/${activityId}/progress`;
}

function FlowActivities(flowId: string, activityId: string) {
  return `/flow/${flowId}/activity/${activityId}/progress`;
}

function ActivityProgress(activityId: string) {
  return `/flow/activity/${activityId}/process`;
}

function ActivityStatus(activityId: string) {
  return `/flow/activity/${activityId}/status`;
}

function ActivityStatusFull(activityId: string) {
  return `/flow/activity/${activityId}/status-full`;
}

function ReportTopic() {
  return "/report";
}

function JoltTopic() {
  return "/jolt";
}

const WebsocketUrlProvider = {
  ActivityStatus,
  ActivityStatusFull,
  FlowProgressForVersion,
  ActivityProgress,
  FlowActivities,
  ReportTopic,
  JoltTopic,
};

export default WebsocketUrlProvider;
